const baseURL = process.env.baseURL || process.env.VUE_APP_API_URL || ""
const mqttWSURL = "ws://192.168.1.8:1884"
const baseType = "" //iA, Shoonis
export default {
    baseURL,
    baseType,
    mqttWSURL
}